import React from 'react';
import { Button, Checkbox, Row, Col } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { FieldGroup } from './FieldGroup';
import { Validator } from './Validator';


export const AggregatorConfigItem = observer(({ item, rules, updateConfigItem, deleteConfigItem, propertyNames, canEdit }) => {
  const updateItem = (name, event) => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    updateConfigItem(item.propertyName, name, value);

    if(name === 'isStaticProperty') {
      if(!target.checked)
        updateConfigItem(item.propertyName, 'staticPropertyValue', '');
      else
        updateConfigItem(item.propertyName, 'propertyMappingValue', '');
    }
}

  const itemRules = rules(item.isStaticProperty);
  const { unsaved } = item;
  return (
    <Row>
      <Col md={2}>
        <Validator rules={itemRules.propertyName}
          fieldName='propertyName' value={item.propertyName} render={({ isValid, message }) => (
            <FieldGroup
              label='Property Name'
              type={ propertyNames ? 'select' : 'input'}
              value={item.propertyName}
              onChange={updateItem.bind(this, 'propertyName')}
              disabled={!unsaved}
              isValid={isValid}
              message={message}
              required
            >
              {
                propertyNames && propertyNames.map((x) => {
                  let val = x.name;
                  if (x.name === '--Select--')
                    val = '';
                  
                  return <option value={val} key={x.name} disabled={x.disabled}>{x.name}</option>
                })
              }
            </FieldGroup>
          )} />
      </Col>
      <Col md={3}>
        <Validator rules={itemRules.propertyMappingValue}
          fieldName='propertyMappingValue' value={item.propertyMappingValue} render={({ isValid, message }) => (
            <FieldGroup
              label='Property Mapping'
              type='text'
              value={item.propertyMappingValue || ''}
              onChange={updateItem.bind(this, 'propertyMappingValue')}
              disabled={item.isStaticProperty}
              isValid={isValid}
              message={message}
              required={!item.isStaticProperty}
            />
      )} />
      </Col>
      <Col md={3}>
        <Validator rules={itemRules.staticPropertyValue}
          fieldName='staticPropertyValue' value={item.staticPropertyValue} render={({ isValid, message }) => (
            <FieldGroup
              label='Static Property'
              type='text'
              value={item.staticPropertyValue || ''}
              onChange={updateItem.bind(this, 'staticPropertyValue')}
              disabled={!item.isStaticProperty}
              isValid={isValid}
              message={message}
              required={item.isStaticProperty}
            />
          )} />
      </Col>
      <Col md={item.isStaticProperty && canEdit ? 1 : 3} className='form-group'>
        <label></label>
        <Checkbox checked={item.isStaticProperty} onChange={updateItem.bind(this, 'isStaticProperty')}>
          Static?
         </Checkbox>
      </Col>
      {
        item.isStaticProperty && canEdit ? 
          <Col md={1} className='form-group'>
            <label></label>
            <Checkbox checked={item.editable || false} onChange={updateItem.bind(this, 'editable')}>
              Publicly Editable?
          </Checkbox>
          </Col> : ''
      }
      {
        item.isStaticProperty && canEdit ?
          <Col md={1} className='form-group'>
            <label></label>
            <Checkbox checked={item.plainText || false} onChange={updateItem.bind(this, 'plainText')}>
              Plain Text?
          </Checkbox>
          </Col> : ''
      }
      <Col md={1} className='form-group' style={{ marginTop: '20px' }}>
        <label></label>
        <Button bsStyle='danger' onClick={deleteConfigItem.bind(this, item.propertyName)}>Delete</Button>
      </Col>
    </Row>
  );
});